module.exports = __webpack_public_path__ + "img/02.16fdc30c.jpg";